<template lang="pug">
  div(:class="`question-${this._uid}`")
    h1(class="question-title") {{this.title}}
    vue-markdown.desc(:source='this.question')

    div.question-content
      section(v-if="this.type.toLowerCase() === 'multi-choice'")
        .input-row(v-for="(n, i) in this.payload.optionValues")
          input(v-model="selection" type="radio" :id="payload.optionLabels[i]" :name="`option-question-${_uid}`" :value="parseInt(n)")
          label.title(:for="payload.optionLabels[i]") {{payload.optionLabels[i]}}
      section(v-if="this.type.toLowerCase() === 'open'")
        input(v-model="selection" type="text" placeholder="your answer")
      section(v-if="this.type.toLowerCase() === 'range'")
        .rangewrap
          input(v-model="selection" type="range" list="ticks" value="0" step="1")
        datalist
          option(v-for="(n, i) in payload.optionValues" :value="n" :label="payload.optionLabels[i]")
        //- .rangeticks
          p(v-for="(n, i) in payload.optionValues") {{payload.optionLabels[i]}}
    div.button.minimal.nextQuestion(:disabled="this.selection === null" v-on:click="emitNext") Next
</template>

<script>
import Vue from 'vue'
import VueMarkdown from 'vue-markdown'

// import sectionBase from '@/components/sections/_sectionBase.js'
// import Collection from '@/components/collection'

// component instance
var Question = Vue.component('question', {
  name: 'Question',
  // mixins: [sectionBase],
  components: { VueMarkdown },
  props: ['payload', 'index', 'id'],
  data: function () {
    return {
      type: this.payload.type || '',
      title: this.payload.title || '',
      question: this.payload.questionPlain || '', // - COMBAK replace this with rich text version when implemented
      options: this.payload.options || [],
      categories: this.payload.categories || [],
      weight: this.payload.weight || '',
      media: this.payload.media,
      selection: null
    }
  },
  watch: {
  },
  methods: {
    emitNext () {
      // console.log('emitNext')
      if (this.selection === null) return false

      const valueLabel = this.payload.optionValues
        ? this.payload.optionLabels[this.payload.optionValues.indexOf(this.selection)]
        : this.selection

      this.$emit('next-question', {
        index: this.index,
        value: this.weightedValue,
        label: valueLabel,
        categories: this.categories,
        questionId: this.id
      })
    }
  },
  computed: {
    weightedValue () {
      return isNaN(this.selection) ? this.selection : this.selection * this.weight
    }
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default Question
</script>

<style scoped lang="scss">
  .question-content{
  }
  .page-title{

  }
</style>



// WEBPACK FOOTER //
// src/components/question.vue